"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var generic_view_1 = require("../generic.view");
var constants_1 = require("../../constants");
var BASE_URI = constants_1.default.BASE_URI;
/**
 * @react-component ExtendSession - Extend User Session view
 */
function ExtendSession(_a) {
    var content = _a.content, route = _a.route;
    var _b = route.enter, _c = (_b === void 0 ? {} : _b).query, _d = (_c === void 0 ? {} : _c).path, pathName = _d === void 0 ? '' : _d, extendSessionData = {
        resultType: 'error',
        headerContent: content.common.extendSession.header,
        bodyContent: content.common.extendSession.body,
        buttonData: {
            name: 'extendSession',
            content: content.common.extendSession.loggedin,
            href: BASE_URI + '/' + pathName
        }
    };
    return React.createElement(generic_view_1.default, tslib_1.__assign({}, extendSessionData));
}
exports.default = ExtendSession;
